// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Wm7B1bLcTziQEX\\+qbdCpiw\\=\\={background:var(--white);border-radius:8px;height:100%;padding:24px;width:100%}", "",{"version":3,"sources":["webpack://./resources/js/v2/pages/merchant/details-only/styles.module.scss"],"names":[],"mappings":"AAAA,6BAIE,uBAAA,CACA,iBAAA,CAHA,WAAA,CACA,YAAA,CAFA,UAKF","sourcesContent":[".detailsOnlyContainer {\n  width: 100%;\n  height: 100%;\n  padding: 24px;\n  background: var(--white);\n  border-radius: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"detailsOnlyContainer": "Wm7B1bLcTziQEX+qbdCpiw=="
};
export default ___CSS_LOADER_EXPORT___;
